import { formatCurrency } from '@/services/format';

export const PURCHASE_NEW_PROPERTY = 'purchase_new_property';
export const SCHEDULED_EQUITY_RELEASE = 'scheduled_equity_release';
export const LUMP_SUM = 'lump_sum';

const MONTHLY_MULTIPLIER_BY_FREQUENCY = {
  weekly: 52 / 12,
  fortnightly: 26 / 12,
  monthly: 1,
  quarterly: 1 / 3,
  annually: 1 / 12,
};

export function findDrawdown(drawdowns, drawdownType) {
  return (drawdowns ?? []).find((drawdown) => drawdown.drawdownType === drawdownType) ?? null;
}

export function toMonthlyAmount(drawdown) {
  if (!drawdown?.amount) {
    return 0;
  }

  return Number(drawdown.amount) * (MONTHLY_MULTIPLIER_BY_FREQUENCY[drawdown.paymentFrequency] ?? 1);
}

export function formatNAOrCurrency(value) {
  if (value === null || value === undefined || value === '' || isNaN(Number(value))) {
    return 'N/A';
  }

  return formatCurrency(value);
}

export function formatNAOrText(value, suffix = '') {
  if (value === null || value === undefined || value === '' || value === 0) {
    return 'N/A';
  }

  return `${value}${suffix}`;
}

export function formatNAOrDate(value) {
  if (!value) {
    return 'N/A';
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return 'N/A';
  }

  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
